__turbopack_context__.v({
  "fullscreenModal": "CommunityNavModal-module-scss-module__e_lKfq__fullscreenModal",
});
